import React, { Component } from "react"
import {validate} from "./validation";
import "../../style/forms.scss";
import { ValidationMessage } from "./validation-message";

export default class Select extends Component{
    constructor(props){
        super(props);
        this.state = {
            value: (typeof(this.props.value) === 'undefined' || this.props.value === null ? '':this.props.value),
            validationResult: {isValid:true,rules:[]}
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);

    }
    componentWillReceiveProps(nextProps){
        if(this.props.value !== nextProps.value){
            this.setState({value: nextProps.value})
        }
        if(typeof(nextProps.validation) !== "undefined" &&
            typeof(nextProps.validation.validationResult) !== "undefined" &&
            nextProps.validation.validationResult.isValid !== this.state.validationResult.isValid){
            this.setState({validationResult: nextProps.validation.validationResult})
        }
    }
    handleChange(event){
        let validationResult = {isValid:true,rules:[]};
        if(typeof(this.props.validation) !== "undefined"){
            let validationRuleResults = validate(this.props.validation,event.target.value);
            validationResult.isValid = validationRuleResults.length === 0;
            validationResult.rules = validationRuleResults;
        }
        let value = event.target.value;
        if(typeof(this.props.format) === "function"){
            value = this.props.format(value);
        }
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.onChange) === "function"){
            this.props.onChange({field: this.props.name, value: event.target.value, validationResult:validationResult});
        }
    }
    handleBlur(event){
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.value;
        if(typeof(this.props.validation) !== "undefined"){
            let validationRuleResults = validate(this.props.validation,value);
            for(let ruleIndex in validationRuleResults){
                validationResult.isValid = validationResult.isValid && validationRuleResults[ruleIndex].isValid
            }
            validationResult.rules = validationRuleResults;
        }
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.onBlur) === "function"){
            this.props.onBlur({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    render(){
        let requiredClass = (this.props.validation && this.props.validation.required === true) ? " required ":""
        let label = this.props.label + ((this.props.validation && this.props.validation.required === true) ? "*":"")

        return (
            <div className={"form-field-group " + requiredClass + (!this.state.validationResult.isValid ? "validation-invalid ":"") + (this.props.readOnly === true ? " field-disabled ":"") + this.props.className}>
                <label className={"form-input-label hidden " + requiredClass}>{label}</label>
                <select className="form-select-input" placeholder={this.props.label} value={this.state.value} onBlur={this.handleBlur} onChange={this.handleChange} ref={this.props.refCallback}>
                    {this.props.options.map(item => {
                        // this is so you can pass just arrays of numbers for date drop downs, if item.key doesn't exist
                        // then just use the value of item because it's probably a number
                      const normalizeMonths = monthNum => monthNum < 10 ? `0${monthNum}` : monthNum;
                        const value = item.key != null ? item.key : item;
                        return <option key={value} value={value}>{item.label ? item.label : normalizeMonths(value)}</option>
                    })}
                </select>
                <ValidationMessage validationResult={this.state.validationResult}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/common/components/forms/select.jsx